// extracted by mini-css-extract-plugin
export var menuIcon = "_k2-0";
export var menuIconInline = "_k2-1";